import { useTranslation } from "@sagot/i18n";
import { cn } from "@sagot/ui";
import { passwordScore } from "../../lib/password";

const SEGMENT_TONE = ["bg-danger-fill", "bg-accent", "bg-primary", "bg-success"] as const;
const LABEL_TONE = ["text-fg-subtle", "text-danger", "text-warning", "text-primary-ink", "text-success"] as const;
const SEGMENTS = [0, 1, 2, 3] as const;

/** `[data-pw-strength]`: 4 segments + label (screens §0 algorithm). */
export function PasswordStrength({ value, id }: { value: string; id?: string }) {
  const { t } = useTranslation();
  const score = passwordScore(value);
  const label = value ? t(`auth.password.strength${String(score)}`) : t("auth.password.hintEmpty");
  return (
    <div id={id} className="mt-2">
      <div className="grid grid-cols-4 gap-1.5" aria-hidden="true">
        {SEGMENTS.map((i) => (
          <span key={i} className={cn("h-1.5 rounded-pill transition-colors", i < score ? SEGMENT_TONE[score - 1] : "bg-line-strong")} />
        ))}
      </div>
      <div className={cn("mt-1.5 text-xs", value ? cn("font-semibold", LABEL_TONE[score]) : "font-medium text-fg-subtle")} aria-live="polite">
        {value ? <span className="sr-only">{t("auth.password.strengthLabel", { label })}</span> : null}
        <span aria-hidden={value ? true : undefined}>{label}</span>
      </div>
    </div>
  );
}
